import React from 'react'
import { useTranslation } from 'react-i18next'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import Stack from '@mui/material/Stack'
import { useMediaQuery, useTheme } from '@mui/material'
import Grid from '@mui/material/Grid'
import { DateTime } from 'luxon'

import logo from 'assets/images/logo-euromaster_2.jpg'
import { StyledFooter, StyledContactLink, StyledLogo } from './styles'

interface Props {
   open: boolean
}

export default function Footer({ open }: Props) {
   const { t } = useTranslation('TRANSLATION')
   const theme = useTheme()
   const isMobile = useMediaQuery(theme.breakpoints.down('lg'))

   return (
      <StyledFooter open={open}>
         <Container maxWidth="xl">
            <Grid container justifyContent={{ xs: 'center', md: 'space-between' }}>
               <Grid size={{ xs: 12, md: 3, lg: 3 }} textAlign="center">
                  <StyledLogo
                     onClick={() => window.open('https://panel.euromaster.pl/sign_in', '_blank')}
                     style={{ marginTop: '5px' }}
                     src={logo}
                     alt="euromaster"
                  />
               </Grid>
               <Grid size={{ xs: 12, md: 3, lg: 3 }}>
                  <Stack direction={{ xs: 'column' }} mb={1} mt={1} textAlign={{ xs: 'center' }}>
                     <StyledContactLink href="mailto:kontakt@motorro.pl">Email: kontakt@motorro.pl</StyledContactLink>
                     <StyledContactLink href="tel:+48507425105">Tel. 507 425 105</StyledContactLink>
                  </Stack>
               </Grid>
               <Grid size={{ xs: 12, md: 3, lg: 3 }}>
                  <Stack direction={{ xs: 'column' }} mb={1} mt={1} textAlign={{ xs: 'center' }}>
                     <StyledContactLink href="https://smr.euromaster.pl/privacy-policy/">
                        {t('TRANSLATION:privacyPolicy')}
                     </StyledContactLink>
                     <StyledContactLink href="https://smr.euromaster.pl/terms-of-use/" target="_blank">
                        {t('TRANSLATION:termsOfUse')}
                     </StyledContactLink>
                  </Stack>
               </Grid>
               {!isMobile && (
                  <Grid size={{ xs: 12, md: 3 }}>
                     <Typography
                        variant="body2"
                        mt={{ xs: 1, sm: 1 }}
                        sx={{
                           color: '#cfd0d4',
                           fontSize: 13,
                           fontWeight: 'bold',
                           textAlign: 'center',
                        }}
                     >
                        {`${t('footer.lastUpdatedDate')}: ${DateTime.fromMillis(
                           Number(process.env.VERSION_TIMESTAMP) * 1000
                        ).toLocaleString(DateTime.DATETIME_MED)}`}
                     </Typography>
                  </Grid>
               )}
               <Grid size={{ xs: 12, md: 12 }}>
                  <Typography
                     variant="body2"
                     sx={{
                        color: '#cfd0d4',
                        fontSize: 13,
                        fontWeight: 'bold',
                        textAlign: 'center',
                     }}
                  >
                     {t('footer.rights', {
                        year: new Date().getFullYear(),
                     })}
                  </Typography>
               </Grid>
            </Grid>
         </Container>
      </StyledFooter>
   )
}
